// extracted by mini-css-extract-plugin
module.exports = {"container":"Overview_container__3OmE_","nav":"Overview_nav__2pzRf","content":"Overview_content__153o3"};